import { useSessionStorage } from '@uidotdev/usehooks'
import { useContext, createContext } from 'react'
import { useACL } from './use-acl'
import { useAxios } from './use-axios'

const TenantContext = createContext(null)

export function useTenant() {
  return useContext(TenantContext)
}

export function TenantProvider({ children }) {
  const { tenants } = useACL()
  const { axios } = useAxios()
  const [tenant, setTenant] = useSessionStorage('Eduseg::Tenant', tenants?.[0])

  axios.defaults.headers.common['X-Tenant'] = tenant?.id

  return <TenantContext.Provider value={{ tenant, tenants, setTenant }}>{children}</TenantContext.Provider>
}
